export class GPSWanderingDetector {
  constructor({ wanderRadius = 15.0, minWanderPoints = 4 } = {}) {
    this.wanderRadius = wanderRadius
    this.minWanderPoints = minWanderPoints
  }

  removeWanderingPoints({ coordinates }) {
    if (coordinates.length < this.minWanderPoints) {
      return coordinates
    }

    const keep = new Array(coordinates.length).fill(true)
    const distances = this._precomputeDistances(coordinates)

    let i = 0
    const limit = this.minWanderPoints

    while (i < coordinates.length - limit + 1) {
      let j = i + 1

      // Quick skip if the next point is already too far
      if (distances[i][j] > this.wanderRadius * 2) {
        i++
        continue
      }

      // Expand wandering segment
      while (j < coordinates.length && distances[i][j] <= this.wanderRadius) {
        j++

        // Cap the wandering segment size
        if (j - i > 50) {
          break
        }
      }

      // If enough points were within the wander radius
      if (j - i >= this.minWanderPoints) {
        for (let k = i + 1; k < j - 1; k++) {
          keep[k] = false
        }
        i = j - 1 // Skip forward to the end of the wandering region
      } else {
        i++
      }
    }

    // Build reduced coordinate list
    const result = []
    for (let idx = 0; idx < coordinates.length; idx++) {
      if (keep[idx]) {
        result.push(coordinates[idx])
      }
    }

    return result
  }

  _precomputeDistances(coords) {
    const n = coords.length
    const distances = Array.from({ length: n }, () => new Array(n).fill(0))

    for (let i = 0; i < n; i++) {
      for (let j = i + 1; j < n; j++) {
        const d = this._haversineDistance(coords[i], coords[j])
        distances[i][j] = d
        distances[j][i] = d
      }
    }
    return distances
  }

  _haversineDistance(p1, p2) {
    const R = 6371000.0
    const lat1 = (p1.lat * Math.PI) / 180
    const lon1 = (p1.lng * Math.PI) / 180
    const lat2 = (p2.lat * Math.PI) / 180
    const lon2 = (p2.lng * Math.PI) / 180

    const x = (lon2, lon1) => (lon2 - lon1) * Math.cos((lat1 + lat2) / 2)
    const dx = x(lon2, lon1)
    const dy = lat2 - lat1

    return Math.sqrt(dx * dx + dy * dy) * R
  }
}
